<template>
  <div>
    <template v-if="target==='list'">
      <div class="MarketList">
        <h2>All Products</h2>
        <el-table
            height="600"
            ref="filterTable"
            :data="product_list"
            :row-style="tableRowClassName"
            class="table">
          <el-table-column
              prop="product_pv"
              label="PV"
              sortable
              align="center"
              width="70">
          </el-table-column>
          <el-table-column
              prop="product_uv"
              label="UV"
              sortable
              align="center"
              width="70">
          </el-table-column>
          <el-table-column
              prop="product_name_en"
              label="Name"
              width="220">
          </el-table-column>
          <el-table-column
              prop="product_default_price"
              label="Default Price"
              align="right"
              width="110">
          </el-table-column>
          <el-table-column
              prop="product_discount"
              label="Discount"
              align="right"
              width="90">
          </el-table-column>
          <el-table-column
              prop="product_total_stock"
              label="Stock"
              align="right"
              sortable
              width="90">
          </el-table-column>
          <el-table-column
              prop="product_sale_count"
              label="Orders"
              align="right"
              width="80">
          </el-table-column>
          <el-table-column
              prop="product_sale_sum"
              label="Revenues"
              align="right"
              width="100">
          </el-table-column>
          <el-table-column
              prop="product_review"
              label="Reviews"
              align="right"
              width="100">
          </el-table-column>
          <el-table-column
              prop="category_name"
              label="Category"
              align="center"
              width="150"
              :filters="category_filter"
              :filter-method="filterTag"
              filter-placement="bottom-end">
            <template slot-scope="scope">
              <el-tag
                  disable-transitions>{{scope.row.category_name}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              prop="sort"
              label="Sort"
              align="center"
              sortable
              width="80">
          </el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  style="width: 70px"
                  @click="onEdit(scope.row.product_id)">Edit
              </el-button>
              <el-button
                  size="mini"
                  style="width: 70px"
                  type="danger"
                  @click="onDelete(scope.$index,scope.row.product_id)">Delete
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
    <template v-if="target==='edit'">
      <MarketCreate @return="onReturn" @back="onReturn" :pid="current_id"></MarketCreate>
    </template>
  </div>
</template>

<script>


  import {deleteProduct, getProductCategory, getProductList} from "@/utils/api";
  import MarketCreate from "@/components/Market/MarketCreate/MarketCreate";

  export default {
    props: {},
    components: {
      MarketCreate
    },
    data: () => {
      return {
        product_list: [],
        category_list: [],
        category_filter: [],
        target: 'list',
        current_id: '',
      }
    },
    beforeMount() {
      this.onRefresh()
    },
    methods: {
      onRefresh() {
        this.$showLoading('Loading');
        getProductCategory().then(res => {
          this.category_list = res.category_list;
          let category_filter = [];
          res.category_list.forEach(v => {
            if (v.product_count !== 0) {
              category_filter.push({
                text: v.pro_category_name_en,
                value: v.pro_category_id
              })
            }
          });
          this.category_filter = category_filter
        });
        getProductList().then(res => {
          this.product_list = res.product_list;
          this.$hideLoading()
        });
      },
      onReturn() {
        this.target = 'list';
        this.onRefresh()
      },
      onEdit(id) {
        this.target = 'edit';
        this.current_id = id
      },
      filterTag(value, row) {
        return row.category_id === value;
      },
      onDelete(index, id) {
        this.$confirm(`Are you sure you want to delete this product?`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          deleteProduct(id).then(res => {
            if (res.errcode === 0) {
              this.product_list.splice(index, 1);
              this.$message({
                type: 'success',
                message: `Product Deleted!`
              });
            }
          });
        }).catch(() => {
        });
      },
      tableRowClassName({row}) {
        if (row.product_total_stock === 0) {
          return 'background: #ebebeb';
        }
        return '';
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "_MarketList.scss";
</style>